import type { Language, Locale } from '@seek/melways-sites';

export const PSEUDO_LANGUAGE = 'en-PSEUDO';
export const PSEUDO_LANGUAGE_MODE = 'enPseudoMode';

export const getVocabLanguage = (language: Language | Locale) =>
  typeof window !== 'undefined' &&
  Boolean(window.localStorage.getItem(PSEUDO_LANGUAGE_MODE))
    ? PSEUDO_LANGUAGE
    : language;
